import {View, StyleSheet} from 'react-native';
import {IGameTopItem} from '../result.type';
import Text from '@/components/basic/text';
import {goTo, toPriceStr} from '@/utils';
import React from 'react';
import theme from '@/style';
import LazyImage from '@/components/basic/image';
import LinearGradient from '@/components/basic/linear-gradient/linear-gradient';
import globalStore from '@/services/global.state';
import {getGameSource} from '../result-service';
import {NativeTouchableOpacity} from '@/components/basic/touchable-opacity';
import {currentBrand} from '@/brands';

const ListItem = ({
  bonus,
  userPhone,
  gameIcon,
  gameName,
  gameId,
  index = 0,
  disabled = true,
  startWithGrey = false,
}: IGameTopItem & {
  index?: number;
  disabled?: boolean;
  startWithGrey?: boolean;
}) => {
  const isAnna = currentBrand.key === 'anna';
  const backgroundColor = React.useMemo(() => {
    if (startWithGrey) {
      return index % 2 === 0 ? '#F3F5FA' : '#fff';
    }
    return index % 2 === 0 ? '#fff' : '#F3F5FA';
  }, [index, startWithGrey]);

  const rank = React.useMemo(() => {
    let textColor = '#fff';
    let bgColors = [];
    let borderColor = '#00000033';
    switch (index) {
      case 0:
        bgColors = ['#E75D16', '#FFC700'];
        break;
      case 1:
        bgColors = ['#4475A2', '#6E8FB6'];
        break;
      case 2:
        bgColors = ['#A27144', '#B6916E'];
        break;
      default:
        textColor = '#7F8896';
        bgColors = ['transparent', 'transparent'];
        borderColor = 'transparent';
        break;
    }
    return (
      <LinearGradient
        colors={bgColors}
        style={[
          styles.rankBadge,
          {
            borderColor,
          },
        ]}>
        <Text
          color={textColor}
          fontFamily="fontInterBold"
          style={styles.rankText}>
          {index + 1}
        </Text>
      </LinearGradient>
    );
  }, [index]);

  const goDetail = () => {
    if (!globalStore.token) {
      goTo('Login', {backPage: 'Home'});
      return;
    }
    globalStore.globalLoading.next(true);
    getGameSource(gameId)
      .then(res => {
        // navigateGame(res.gameName, res.gameUrl);
        goTo('WebView', {
          header: true,
          hideAmount: true,
          headerTitle: res.gameName,
          originUrl: res.gameUrl,
        });
      })
      .finally(() => {
        globalStore.globalLoading.next(false);
      });
  };

  return (
    <NativeTouchableOpacity
      disabled={disabled}
      onPress={goDetail}
      style={[
        theme.flex.row,
        theme.flex.centerByCol,
        theme.margin.lrl,
        theme.padding.l,
        styles.row,
        isAnna && styles.annaRow,
        {backgroundColor},
      ]}>
      <View
        style={[
          theme.flex.flex1,
          theme.flex.row,
          theme.flex.centerByCol,
          styles.mainCol,
        ]}>
        {rank}
        <LazyImage
          radius={4}
          imageUrl={gameIcon}
          width={theme.iconSize.xxl}
          height={theme.iconSize.xxl}
        />
        <Text size="small" fontWeight="500" style={styles.gameName}>
          {gameName}
        </Text>
      </View>
      <View style={[styles.infoCol]}>
        <Text size="small" fontWeight="500" textAlign="center" second>
          {userPhone}
        </Text>
      </View>
      <View style={[styles.infoCol]}>
        <Text size="small" textAlign="right" fontFamily="fontInterBold" main>
          {toPriceStr(bonus, {fixed: 1})}
        </Text>
      </View>
    </NativeTouchableOpacity>
  );
};

const styles = StyleSheet.create({
  rankBadge: {
    width: 16,
    height: 16,
    borderRadius: 4,
    borderWidth: 1,
    justifyContent: 'center',
    alignItems: 'center',
  },
  rankText: {
    includeFontPadding: false,
    fontSize: 10,
  },
  row: {
    columnGap: theme.paddingSize.s,
    paddingVertical: 12,
  },
  annaRow: {
    minHeight: 58,
    paddingVertical: 12,
  },
  mainCol: {
    columnGap: theme.paddingSize.s,
  },
  gameName: {
    width: 80,
  },
  infoCol: {
    width: theme.paddingSize.s * 10,
  },
});

export default ListItem;
